<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Student History</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row>
        <v-col sm="3" md="3"></v-col>
        <v-col sm="6" md="6">
          <v-autocomplete :items="stud_list" v-model="stud_data" item-text="name" label="Search Student" dense
            return-object rounded outlined :loading="comp_load" placeholder="Search by PRN No or name"
            @click="show = false"></v-autocomplete>
        </v-col>
        <v-col sm="3" md="3">
          <v-btn @click="getData()" :loading="fetch_loader" class="button mt-1 pt-0">Fetch</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <!-- details of student -->
    <v-card class="box" v-if="fee_list != '' && show == true">
      <v-expansion-panels class="expapanel no-display" focusable inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="panelheader">Fee Details
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5">
            <!-- table content -->

            <!-- <v-data-table
              :headers="headers_1"
              :items="fee_list"
              dense
              class="elevation-1 mytable"
            >
             
            </v-data-table> -->

            <v-simple-table fixed-header dense class="elevation-1 mytable">
              <tbody>
                <tr>
                  <th>
                    <center>Academic Year</center>
                  </th>
                  <th>
                    <center>Total Fees</center>
                  </th>
                  <th>
                    <center>Total Paid</center>
                  </th>
                  <th>
                    <center>Print Receipt</center>
                  </th>
                </tr>

                <tr v-for="(crsdata, j) in fee_list" :key="j">
                  <td>
                    {{ crsdata.academic_year }}
                  </td>
                  <td>
                    {{ crsdata.learner_total_amt }}
                  </td>
                  <td>
                    {{ crsdata.learner_paid_amt }}
                  </td>
                  <td>
                    <span v-for="(recpid, k) in crsdata.receipt_id" :key="k">
                      <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                            @click="print(recpid, crsdata.ay, crsdata.learner)">
                            <v-icon color="warning">mdi-printer</v-icon>
                            {{ recpid }}
                          </v-btn>
                        </template>
                        <span> Print Fee Receipt!!! </span>
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- table end -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-card class="box" v-if="examination_list != '' && show == true">
      <!-- <div v-for="(cofff_data, i) in examination_list" :key="i">
        {{ cofff_data.academic_year }}
        <span v-for="(subdata, j) in cofff_data.coff_data" :key="j">
          {{ subdata.course }} <br />
          {{ subdata.course_grade }}
        </span>
      </div> -->

      <v-expansion-panels class="expapanel no-display" focusable inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="panelheader">Academic Details
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5">
            <!-- table content -->

            <div v-for="(cofff_data, i) in examination_list" :key="i">
              <center>
                <b> {{ cofff_data.academic_year }}</b>
              </center>
              <v-simple-table fixed-header class="elevation-1" height="300px">
                <thead class="acadhead">
                  <tr>
                    <th>
                      <center>Sr. No.</center>
                    </th>
                    <th>
                      <center>Course Name</center>
                    </th>
                    <th>
                      <center>Grades</center>
                    </th>
                    <th>
                      <center>Marks</center>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <th><center>Sr. No.</center></th>
                    <th><center>Course Name</center></th>
                    <th><center>Grades</center></th>
                    <th><center>Marks</center></th>
                  </tr> -->

                  <tr v-for="(subdata, j) in cofff_data.coff_data" :key="subdata.course">
                    <td>{{ j + 1 }}</td>
                    <td>
                      {{ subdata.course }}
                    </td>
                    <td>
                      <!-- object iteration propertyName used for key & grades for value -->
                      <span v-for="(
                          grades, propertyName, k
                        ) in subdata.course_grade" :key="k">
                        {{ propertyName }}&nbsp;&nbsp;::&nbsp;&nbsp;
                        {{ grades }}
                      </span>
                    </td>
                    <td>
                      <span v-for="(marks, propertyName, k) in subdata.course_marks" :key="k">
                        {{ propertyName }}&nbsp;&nbsp;::&nbsp;&nbsp;
                        {{ marks }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            <!-- table end -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-card class="box" v-if="outstanding_list.length != '' && show == true">
      <!-- outstanding_list--{{ outstanding_list.academic_year }} <br /> -->

      <v-expansion-panels class="expapanel no-display" focusable inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="panelheader">Outstanding Details
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5">
            <!-- table content -->

            <!-- <v-data-table
              :headers="headers_2"
              :items="outstanding_list"
              dense
              class="elevation-1 mytable"
            >
            </v-data-table> -->
            <v-simple-table fixed-header dense class="elevation-1 mytable">
              <tbody>
                <tr>
                  <th>
                    <center>Academic Year</center>
                  </th>
                  <th>
                    <center>Total Outstanding</center>
                  </th>
                  <th>
                    <center>Total Paid Outstanding</center>
                  </th>
                  <th>
                    <center>Print Receipt</center>
                  </th>
                </tr>

                <tr v-for="(outdata, j) in outstanding_list" :key="j">
                  <td>
                    {{ outdata.academic_year }}
                  </td>
                  <td>
                    {{ outdata.fee }}
                  </td>
                  <td>
                    {{ outdata.paid_till_now }}
                  </td>
                  <td>
                    <span v-for="(recpid, k) in outdata.receipt_id" :key="k">
                      <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                            @click="
                              print1(recpid, outdata.ay[k], outdata.learner)
                            ">
                            <v-icon color="warning">mdi-printer</v-icon>
                            {{ recpid }}
                          </v-btn>
                        </template>
                        <span> Print Fee Receipt!!! </span>
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- table end -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-card class="box" v-if="misc_fee_list.length != '' && show == true">
      <v-expansion-panels class="expapanel no-display" focusable inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="panelheader">Misc Fee Details
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-5">
            <!-- table content -->
            <v-simple-table fixed-header dense class="elevation-1 mytable">
              <tbody>
                <tr>
                  <th>
                    <center>Academic Year</center>
                  </th>
                  <th>
                    <center>Misc fees</center>
                  </th>

                  <th>
                    <center>Print Receipt</center>
                  </th>
                </tr>

                <tr v-for="(miscdata, j) in misc_fee_list" :key="j">
                  <td>
                    {{ miscdata.academic_year }}
                  </td>
                  <td>
                    <span v-for="(miscamt, m) in miscdata.learner_misc_amt" :key="m">
                      {{ miscamt }}
                    </span>
                    <!-- {{ miscdata.learner_misc_amt }} -->
                  </td>

                  <td>
                    <span v-for="(recpid, k) in miscdata.receipt_id" :key="k">
                      <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                            @click="
                              print2(recpid, miscdata.ay, miscdata.learner)
                            ">
                            <v-icon color="warning">mdi-printer</v-icon>
                            {{ recpid }}
                          </v-btn>
                        </template>
                        <span> Print Fee Receipt!!! </span>
                      </v-tooltip>
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <!-- table end -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    comp_load: false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    stud_list: null,
    stud_data: null,
    fetch_loader: false,
    aylist: null,
    ay: null,
    snackbar: false,
    snackbar_msg: "",
    color: "",
    fee_list: [],
    examination_list: [],
    // coff_data: [],
    outstanding_list: [],
    misc_fee_list: [],
    org_id: null,
    receipt_no: null,
    show: false,

    headers_1: [
      { text: "Academic Year", value: "academic_year" },
      { text: "Total Fees ", value: "learner_total_amt" },
      { text: "Total Paid", value: "learner_paid_amt" },
      { text: "Receipts", value: "receipt_id" },
      { text: "Receipt Print", value: "print" },
    ],
    headers_2: [
      { text: "Academic Year", value: "academic_year" },
      { text: "Total Outstanding ", value: "fee" },
      { text: "Total Paid Outstanding", value: "paid_till_now" },
      //   { text: "Receipts", value: "receipt_id" },
    ],
  }),
  mounted() {
    this.comp_load = true;
    this.org_id = localStorage.getItem("EPS-tenant");

    axios
      .post("/admission/getAllStudents")
      .then((res) => {
        if (res.data.msg == "200") {
          this.stud_list = res.data.stud_list;
        } else {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        }
      })
      .catch((error) => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {
        this.comp_load = false;
      });
  },
  methods: {
    // print(recpid, academic_year) {
    //   console.log("in print method", recpid, academic_year);
    // },

    print2(receipt_no, ay, registration_number) {
      //   alert(receipt_no);
      //   alert(ay);
      //   alert(registration_number);
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      this.$session.set("registration_no", JSON.stringify(registration_number));
      // this.$router.push({
      //     name: "misc-other-exam-fees-payment-receipt",
      // });
      let routeData = this.$router.resolve({
        name: "misc-other-exam-fees-payment-receipt",
      });
      window.open(routeData.href, "_blank");
    },

    print1(receipt_no, ay, registration_number) {
      //   alert(receipt_no);
      //   alert(ay);
      //   alert(registration_number);
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      this.$session.set("registration_no", JSON.stringify(registration_number));
      // this.$router.push({
      //     name: "student-outstanding-payment-receipt",
      // });
      let routeData = this.$router.resolve({
        name: "student-outstanding-payment-receipt",
      });
      window.open(routeData.href, "_blank");
    },

    print(receipt_no, ay, registration_number) {
      //   alert(receipt_no);
      //   alert(ay);
      //   alert(registration_number);
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      this.$session.set("registration_no", JSON.stringify(registration_number));
      if (this.org_id == "zeal") {
        let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
        window.open(routeData.href, "_blank");
      } else if (this.org_id == "wws") {
        let routeData = this.$router.resolve({
          name: "student-fees-receipts-wws",
        });
        window.open(routeData.href, "_blank");
      }
      else if (this.org_id == "uwws") {
        let routeData = this.$router.resolve({
          name: "student-fees-receipts-uwws",
      });
        window.open(routeData.href, "_blank");
      } 
      else if (this.org_id == "sanjivani") {
      let routeData = this.$router.resolve({
      name: "student-fees-receipts-sanjivani",
      });
      window.open(routeData.href, "_blank");
      }
      else {
        let routeData = this.$router.resolve({ name: "student-fees-receipts" });
        window.open(routeData.href, "_blank");
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    getData() {
      const data = {
        lid: this.stud_data,
      };
      axios
        .post("/Academics/getLernerHistory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.show = true;
            this.fee_list = res.data.fee_list;
            this.examination_list = res.data.examination_list;
            // this.coff_data = res.data.examination_list.coff_data;
            this.outstanding_list = res.data.outstanding_list;
            this.misc_fee_list = res.data.misc_fee_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
th {
  /* background-color: #0f2027 !important; */
  background: linear-gradient(to right, #265fb1, #b6fbff) !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.flash {
  animation-name: flash;
  animation-duration: 0.9s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-play-state: running;
}

@keyframes flash {
  from {
    color: red;
  }
  to {
    color: white;
  }
}

/* shiv css */
.expapanel {
  /* width: 93%; */
  /* margin-left: 1%; */
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;

  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
/* .acadhead {
  background: #83a4d4; 
  background: linear-gradient(to right, #265fb1, #b6fbff) !important;
  background: -webkit-linear-gradient(to right, #265fb1, #b6fbff) !important;
  background: linear-gradient(to right, #265fb1, #b6fbff) !important;
} */
</style>
